module.exports = __webpack_public_path__ + "img/40_81.3596d4aa.png";